import PropTypes from "prop-types"

const PreviewPathStep = ({ pathItem }) => {
  return <div>{pathItem.name}</div>
}

PreviewPathStep.displayName = "PreviewPathStep"

PreviewPathStep.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default PreviewPathStep
